// extracted by mini-css-extract-plugin
module.exports = {"patientCol":"Table_patientCol__oB3_F"};